import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-nav', 'search', 'Paieška');
Labels.set('ui-nav', 'searchOpen', 'Atidaryti paieškos formą');
Labels.set('ui-nav', 'searchClose', 'Uždaryti paieškos formą');
